export default __webpack_public_path__ + "static/media/Balaji jewellers.d04b08aa.png";